<script lang="ts" setup>
  defineProps({
    tooltipText: {
      type: String,
      required: true,
    },
  });
</script>

<template>
  <div class="tooltip">{{ tooltipText }}</div>
</template>

<style lang="scss">
  @use "shared/styles/colors";

  .tooltip {
    color: colors.$color_tooltip--text;
    background-color: colors.$color_tooltip--background;

    font-size: 12px;

    padding: 7px;
  }
</style>
